<script>
	import { getContext } from 'svelte';
	const { data, xGet, yGet, height, width } = getContext('LayerCake');
	export let colorScale = d => '#000';

	export let fill = '#5b9aa0';



	$: columnHeight = d => {
		return $height - $yGet(d);
	};

	//let columnWidth = $width / $data[0]['values'].length;

	let columnWidth = 10;


	const stroke = '#333333';
	const strokeWidth = 1;
	export let barstroke = '#cccccc';


	const r = 4;


</script>


<g class="column-group">
	{#each $data[0]['values'] as d, i}
		<rect
			class='group-rect'
			data-id="{i}"
			x="{$xGet(d)-columnWidth/2}"
			y="{$yGet(d)}"
			width="{columnWidth}"
			height="{columnHeight(d)}"
			{fill}
			stroke="{barstroke}"
			stroke-width="{strokeWidth}"
		></rect>
	{/each}
</g>


